import { Saga } from 'redux-saga'

const sagas: Saga[] = []

export { sagas }
